/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AdminCreate = {
    properties: {
        username: {
            type: 'string',
            isRequired: true,
            maxLength: 320,
            minLength: 3,
        },
        operatorId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        name: {
            type: 'string',
            isRequired: true,
            maxLength: 100,
        },
        email: {
            type: 'string',
            isRequired: true,
            format: 'email',
            maxLength: 320,
            minLength: 7,
        },
        phoneNumber: {
            type: 'string',
            isNullable: true,
            maxLength: 18,
            minLength: 10,
        },
        password: {
            type: 'string',
            isNullable: true,
        },
        userRoleId: {
            type: 'number',
            isRequired: true,
            format: 'int32',
        },
        forcePasswordReset: {
            type: 'boolean',
        },
    },
};